import { Grid, styled } from '@material-ui/core'
import { Typography } from 'components'
import { getCurrentFont } from 'config/theme'
import { isFitanu } from 'config/theme'
import { colors } from 'config'

export const Wrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: colors.landing.black,
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: getCurrentFont('korolev, sans-serif'),
  fontSize: 67,
  lineHeight: '63px',
  color: theme.palette.common.white,
  letterSpacing: 0.8375,
  fontWeight: 'bold',
  marginBottom: theme.spacing(5.5),
  [theme.breakpoints.down('md')]: {
    fontSize: 57,
    lineHeight: '53px',
    marginBottom: theme.spacing(3.5),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 37,
    lineHeight: '39px',
  },
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.common.white,
  lineHeight: '24px',
  letterSpacing: 0.06,
  '&:not(:first-child)': {
    marginTop: theme.spacing(2.5),
  },
  [theme.breakpoints.down('md')]: {
    fontSize: 17,
    lineHeight: '22px',
    marginTop: theme.spacing(1.75),
  },
}))

export const ButtonsWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(9),
  '& > button:first-child': {
    marginRight: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(6),
  },
  [theme.breakpoints.down('xs')]: {
    marginTop: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: 360,
    flexWrap: 'wrap',
    '& > button': {
      marginTop: theme.spacing(2),
    },
  },
}))

export const LeftContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(20.5, 0, 18, 19.5),
  boxSizing: 'border-box',
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(14, 0, 12, 14),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(10, 0, 9, 10),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(7.5, 4.5, 6, 4.5),
  },
}))

export const RightContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    minHeight: 400,
  },
}))

export const Link = styled('a')(({ theme }) => ({
  color: theme.palette.primary.main,
}))

export const Image = styled('img')(({ theme }) => ({
  height: '95%',
  position: 'absolute',
  bottom: 0,
  right: theme.spacing(19.5),
  [theme.breakpoints.up('lg')]: {
    right: theme.spacing(13),
    ...(isFitanu()
      ? {
          height: '68%',
        }
      : {
          height: '75%',
        }),
  },
  [theme.breakpoints.up('xl')]: {
    right: theme.spacing(14),
    ...(isFitanu()
      ? {
          height: '78%',
        }
      : {
          height: '80%',
        }),
  },
  [theme.breakpoints.down('md')]: {
    right: theme.spacing(3.5),
    height: '64%',
  },
  [theme.breakpoints.down('sm')]: {
    left: '50%',
    transform: 'translateX(-50%)',
    height: '92%',
  },
  [theme.breakpoints.down('xs')]: {
    left: '50%',
    transform: 'translateX(-50%)',
    height: '92%',
  },
}))
